import { render, staticRenderFns } from "./medkon_stasiun_tv.vue?vue&type=template&id=d2d3a544&"
import script from "./medkon_stasiun_tv.vue?vue&type=script&lang=js&"
export * from "./medkon_stasiun_tv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports